// extracted by mini-css-extract-plugin
module.exports = {"dropdownIcon":"messageModal_dropdownIcon__1OxVk","dropdownFilesWidth":"messageModal_dropdownFilesWidth__yg8Ls"};